<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="900px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <el-overlay-loading :loading="pageloading" />
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>NT objektų tikslinimas</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 pb-4">
          <v-card-text>
            <v-data-table
              :headers="filteredHeaders"
              :items="itemsList"
              :loading="tableLoading"
              :search="search"
              :footer-props="{
                showFirstLastPage: true,
                showCurrentPage: true,
                itemsPerPageText: 'Rodyti po:',
                itemsPerPageAllText: 'visi',
                itemsPerPageOptions: itemsPerPageOptions,
              }"
              :hide-default-footer="hideFooter"
              :items-per-page="pageSize"
              single-expand
              :expanded.sync="expanded"
              item-key="tur_ntr_registras"
            >
              <template #top>
                <v-toolbar flat>
                  <v-text-field
                    v-model="search"
                    prepend-icon="mdi-magnify"
                    label=""
                    single-line
                    hide-details
                  ></v-text-field>
                  <v-spacer></v-spacer>
                </v-toolbar>
              </template>
              <template #[`header.actions`]="{ header }">
                {{ header.text }}
                <el-checkbox
                  class="align-center justify-center mt-0"
                  :validate-key="`check-all`"
                  v-model="headerCheck"
                  @click.native.stop="checkAll()"
                />
              </template>
              <template #[`header.busena`]="{ header }">
                {{ header.text }}<br />
                {{ header.text2 }}
              </template>
              <template #[`item.actions`]="{ item }">
                <div class="text-center mb-2">
                  <el-checkbox
                    v-if="item.canCheck"
                    :validate-key="`check-${item.tur_ntr_registras}`"
                    v-model="registrai"
                    :checkValue="item.tur_ntr_registras"
                    :key="item.tur_ntr_registras"
                  />
                </div>
              </template>
              <template #[`item.busena`]="{ item }">
                <div class="my-1">
                  <template v-if="item.uzs_paslaugos_pra_id">
                    {{ item.uzs_paslaugos_pra_id }}<br />
                  </template>
                  <el-busena :busena="item.busena" />
                </div>
              </template>
              <template #[`item.vertinimas`]="{ item }">
                {{ item.vertinimasKainaFormat }}
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      dense
                      class="table-action mx-1"
                      v-bind="attrs"
                      v-on="on"
                      @click="viewExpanded(item)"
                    >
                      mdi-eye-check
                    </v-icon>
                  </template>
                  <div class="tooltip-text">
                    Vertinimo informacija
                  </div>
                </v-tooltip>
              </template>
              <template #[`item.atsaukti`]="{ item }">
                <el-button
                  v-if="item.canAtsaukti"
                  :disabled="loading"
                  @click.native.stop="openConfirmAtsaukti(item)"
                  x-small
                >
                  Atšaukti tikslinimą
                </el-button>
              </template>
              <template #[`body.append`]>
                <tr>
                  <td :colspan="filteredHeaders.length - 2" class="text-end">
                    <strong>Kaina iš viso, Eur:</strong>
                  </td>
                  <td class="text-center">{{ visoVerte }}</td>
                  <td></td>
                </tr>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length">
                  <modal-ntr-tikslinimas-turtas
                    :key="`turtai-${item.tur_ntr_registras}`"
                    :turtai="item.turtai"
                    :skuba="item.skuba"
                    :skubos="skubos"
                    :can-check="item.canCheck"
                    :can-skuba-change-all="item.canSkubaChangeAll"
                    @skubaChange="skubaChange(item, ...arguments)"
                    @skubaChangeAll="skubaChangeAll"
                  />
                </td>
              </template>
              <template slot="loading">
                Kraunasi...
              </template>
              <template slot="no-results">
                Duomenų nėra
              </template>
              <template slot="no-data">
                Duomenų nėra
              </template>
              <template #[`footer.page-text`]="props">
                Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
                {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancelData()" :loading="loading">
          Uždaryti
        </el-button>
        <el-button
          primary
          :disabled="!enableSubmit"
          :loading="loading"
          @click.native.stop="openConfirmUzsakyti()"
        >
          Tikslinti
        </el-button>
      </v-card-actions>
    </v-card>

    <modal-confirm
      :title="confirmTitle"
      :text="confirmText"
      :action="confirmAction"
      :item="confirmItem"
      v-model="showConfirm"
      @confirmTikslinimas="saveData"
      @confirmAtsaukti="saveAtsaukti"
      @cancelConfirm="cancelConfirm"
    />
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import math from '../../mixins/math'
import ModalConfirm from './ModalConfirm'
import ModalNtrTikslinimasTurtas from './ModalNtrTikslinimasTurtas'

export default {
  name: 'ModalNtrTikslinimas',
  props: {
    value: Boolean,
  },
  components: {
    ModalConfirm,
    ModalNtrTikslinimasTurtas,
  },
  mixins: [math],
  data() {
    return {
      pageloading: false,
      loading: false,
      tableLoading: false,
      tikslinimai: [
        {
          turtai: [],
          vertinimasKaina: 0,
          skuba: 0,
        },
      ],
      skubos: [],
      registrai: [],
      headerCheck: false,
      confirmTitle: null,
      confirmText: null,
      confirmAction: null,
      confirmItem: null,
      showConfirm: false,
      search: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
      expanded: [],
    }
  },
  computed: {
    ...mapGetters(['objektasID']),
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    headers() {
      return [
        {
          text: 'Užsakyti',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: 'Registras',
          align: 'start',
          value: 'tur_ntr_registras',
        },
        {
          text: 'Užsakymo Nr.',
          text2: 'Tikslinimo būsena',
          align: 'center',
          value: 'busena',
        },
        {
          text: 'Tikslinimo data',
          align: 'start',
          value: 'data',
        },
        {
          text: 'Kaina, Eur',
          align: 'center',
          value: 'kainaFormat',
        },
        {
          text: 'Vertinimas, Eur',
          align: 'center',
          value: 'vertinimas',
        },
        {
          text: 'Veiksmai',
          align: 'start',
          sortable: false,
          value: 'atsaukti',
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.tikslinimai.map(item => {
        item.kainaFormat = this.moneyformat(item.kaina)
        item.vertinimasKaina = this.vertinimasKaina(item)
        item.vertinimasKainaFormat = this.moneyformat(item.vertinimasKaina)

        item.canAtsaukti =
          item.uzs_id &&
          item.busena !== 'Įvykdytas' &&
          item.busena !== 'Atliktas' &&
          item.busena !== 'Atmestas' &&
          item.busena !== 'Atšauktas'
        item.canCheck = !item.canAtsaukti
        item.canView = true
        item.canSkubaChangeAll = !item.busena
        return item
      })
    },
    hideFooter() {
      return this.itemsList.length <= 10
    },
    visoVerte() {
      return this.moneyformat(
        this.tikslinimai
          .map(item =>
            item.kaina > 0 && this.registrai.includes(item.tur_ntr_registras)
              ? item.kaina + this.vertinimasKaina(item)
              : 0
          )
          .reduce((accumulator, currentValue) => {
            return accumulator + currentValue
          }, 0)
      )
    },
    enableSubmit() {
      return this.registrai.length > 0
    },
    tikslinimasBusenos() {
      return [
        'Atmestas',
        'Naujas',
        'Vykdomas',
        'Įvykdytas',
        'Dal. įvykdytas',
        'Atliktas',
        'Atnaujintas',
        'Atidėtas',
        'Atšauktas',
      ]
    },
  },
  watch: {
    showModal(val) {
      if (val) {
        this.expanded = []
        this.getData(true)
      }
    },
  },
  methods: {
    getData(firstLoad = false) {
      this.pageloading = firstLoad
      this.loading = true
      this.tableLoading = true
      this.$axios
        .get(`objektas/${this.objektasID}/turtas/ntr-tikslinimas`)
        .then(res => {
          this.registrai = []
          this.headerCheck = false
          this.tikslinimai = res.data.tikslinimai
          this.skubos = res.data.skubos
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.tableLoading = false
          this.loading = false
          this.pageloading = false
        })
    },
    saveData() {
      this.loading = true

      const tikslinti = this.tikslinimai
        .filter(tikslinimas =>
          this.registrai.includes(tikslinimas.tur_ntr_registras)
        )
        .map(tikslinimas => {
          return {
            reg_nr: tikslinimas.tur_ntr_registras,
            skuba: tikslinimas.skuba,
          }
        })
      const data = {
        obj_id: this.objektasID,
        registrai: tikslinti,
      }

      this.$axios
        .post(`objektas/${this.objektasID}/turtas/ntr-tikslinimas`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.closeModal()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveAtsaukti(item) {
      this.loading = true

      this.$axios
        .delete(
          `objektas/${this.objektasID}/turtas/ntr-tikslinimas/${item.uzs_id}`
        )
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.getData()
        })
    },
    cancelData() {
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
    cancelConfirm() {
      this.showConfirm = false
    },
    openConfirmUzsakyti() {
      this.confirmTitle = 'NT objektų tikslinimas'
      this.confirmText = 'Ar tikrai norite užsakyti šių NT objektų tikslinimą?'
      this.confirmAction = 'Tikslinimas'
      this.confirmItem = null
      this.showConfirm = true
    },
    openConfirmAtsaukti(item) {
      this.confirmTitle = 'NT objektų tikslinimo atšaukimas'
      this.confirmText = `Ar tikrai norite atšaukti NT objekto <b>${item.tur_ntr_registras}</b> tikslinimą?`
      this.confirmAction = 'Atsaukti'
      this.confirmItem = item
      this.showConfirm = true
    },
    checkAll() {
      this.registrai = []
      if (this.headerCheck) {
        this.tikslinimai.forEach(item => {
          if (item.canCheck) {
            this.registrai.push(item.tur_ntr_registras)
          }
        })
      }
    },
    viewExpanded(item) {
      if (this.expanded[0] === item) {
        this.expanded = []
      } else {
        this.expanded = [item]
      }
    },
    vertinimasKaina(item) {
      return item.turtai
        .map(turtas =>
          !turtas.vertinimas_galiojantis ? turtas.kainos[item.skuba] : 0
        )
        .reduce((accumulator, currentValue) => {
          return accumulator + currentValue
        }, 0)
    },
    skubaChange(item, value) {
      item.skuba = value
    },
    skubaChangeAll(value) {
      this.tikslinimai.forEach(item => {
        if (!item.busena) {
          item.skuba = value
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
